function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRemoveIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "warning-remove-icn",
    d: "M70.563 35.562a35 35 0 1 1-35-35 35 35 0 0 1 35 35zm-35 7.056a6.492 6.492 0 1 0 6.492 6.492 6.492 6.492 0 0 0-6.493-6.491zM29.4 19.284l1.047 19.194a1.694 1.694 0 0 0 1.691 1.6h6.851a1.693 1.693 0 0 0 1.691-1.6l1.047-19.194a1.694 1.694 0 0 0-1.692-1.784H31.09a1.693 1.693 0 0 0-1.69 1.784z",
    transform: "translate(-.562 -.562)",
    style: {
      fill: "#dc3545"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRemoveIcn);
export default __webpack_public_path__ + "static/media/warning-remove-icn.da016cab8d474ca20065880fc5e604a1.svg";
export { ForwardRef as ReactComponent };